import { STATUS_TYPE } from '../../../enum';

export interface GetWalletTransaction {
  id: string;
}

export interface FindWalletTransaction {
  userId?: string;
  limit?: number;
  skip?: number;
}

export interface CreatePatchWalletTransaction {
  id?: string;
  amount: string;
  userId: string;
  paymentMethod: string;
  cdType?: 'C' | 'D';
}

export interface WalletTransaction {
  id: string;
  amount: string;
  userId: string;
  orderId: string;
  paymentDetails: string;
  paymentMethod: string;
  cdType?: 'C' | 'D';
  createdBy: string;
  updatedBy: string;
  updatedAt: string;
  createdAt: string;
}

interface InitialState {
  data: WalletTransaction[];
  skip: number;
  limit: number;
  totalRecords: number;
  currentPage: number;
  status: STATUS_TYPE;
  isError: boolean;
  isLoading: boolean;
  isSuccess: boolean;
  errorMessage: string;
}

export const initialState: InitialState = {
  data: [],
  skip: 0,
  limit: 25,
  totalRecords: 0,
  currentPage: 0,
  status: 'idle',
  isError: false,
  isLoading: false,
  isSuccess: false,
  errorMessage: '',
};
